import {
  GET_PESEES,
  ADD_PESEE,
  UPDATE_PESEE,
  DELETE_PESEE
} from '../actions/action-types';

const initialState = {
  list: []
};

export default function peseesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PESEES:
      return { ...state, list: action.payload || [] };
    case ADD_PESEE:
      return { ...state, list: [action.payload, ...state.list] };
    case UPDATE_PESEE:
      return {
        ...state,
        list: state.list.map(p => p.id === action.payload.id ? { ...p, ...action.payload } : p)
      };
    case DELETE_PESEE:
      return { ...state, list: state.list.filter(p => p.id !== action.payload) };
    default:
      return state;
  }
}
